import * as types from './mutation-types'
/* eslint-disable */

export const loadStands = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/list/' + data.event_id + '/stand', {params: data}).then((response) => {
            commit(types.LOAD_STANDS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const createStand = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/stand', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateStand = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.put('update/' + data.id + '/stand', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getEventStand = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/detail/' + id + '/stand').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteStand = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('delete/' + id + '/stand').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}